// extracted by mini-css-extract-plugin
export default {"hideScrollbar":"CalendarModal_hideScrollbar__4rPjf"};